module.exports = __webpack_public_path__ + "media/application/images/share-3314cb11a108e7f6ac01bf35bad7d758.svg";